import { Button, Flex, Typography, Upload } from "antd";
import { RcFile } from "antd/es/upload";
import { DocumentFileRow } from "@entities/journal";
import { DocumentSelectorWrapper } from "@features/document-selector-wrapper";
import { RedCloseIcon } from "@shared/assets/svg/icons";
import { useIsUnifiedMode } from "@shared/utils";

import "./form-file-selector.scss";

interface FormFileSelectorProps {
  defaultFileName?: string;
  defaultFileSize?: number;
  defaultFileLink?: string;
  defaultFileId?: string;
  onFileSelect: (file: RcFile) => void;
  onFileRemove: () => void;
}

const archiveMimeTypes = ["application/zip"];

const accept = ["application/pdf", ...archiveMimeTypes];

export function FormFileSelector({
  defaultFileName,
  defaultFileSize,
  defaultFileLink,
  defaultFileId,
  onFileSelect,
  onFileRemove,
}: FormFileSelectorProps) {
  const isUnifiedMode = useIsUnifiedMode();

  return (
    <Flex className="form-file-selector" vertical>
      <Typography.Text className="form-file-selector-label">
        Цифровая копия журнала (необязательно)
      </Typography.Text>
      <Typography.Text
        type="secondary"
        className="form-file-selector-description"
      >
        Прикрепите скан-копию или архив
      </Typography.Text>
      <DocumentSelectorWrapper
        defaultFileName={defaultFileName}
        defaultFileLink={defaultFileLink}
        defaultFileSize={defaultFileSize}
        onFileRemove={onFileRemove}
        onFileSelect={onFileSelect}
      >
        {({
          selected,
          handleFileSelect,
          handleFileRemove,
          selectedFileLink,
          selectedFileName,
        }) => {
          const isBlobLink = selectedFileLink?.startsWith("blob:");
          const hasServerFileId = Boolean(defaultFileId && !isBlobLink);

          return selected ? (
            <Flex gap="8px" align="center">
              <DocumentFileRow
                className="form-file-selector-link-row"
                linkClassName="form-file-selector-link"
                fileName={selectedFileName ?? "document.pdf"}
                fileId={hasServerFileId ? defaultFileId : undefined}
                documentUrl={
                  hasServerFileId || isBlobLink ? undefined : selectedFileLink
                }
                blobUrl={isBlobLink ? selectedFileLink : undefined}
                disableLinkAction={isUnifiedMode}
              />
              <Button
                icon={<RedCloseIcon />}
                type="text"
                className="form-file-selector-close"
                onClick={handleFileRemove}
              />
            </Flex>
          ) : (
            <Upload
              multiple={false}
              maxCount={1}
              name="permission"
              showUploadList={false}
              accept={accept?.filter(Boolean).join(",")}
              beforeUpload={() => false}
              onChange={handleFileSelect}
            >
              <Button className="form-file-selector-button">Загрузить</Button>
            </Upload>
          );
        }}
      </DocumentSelectorWrapper>
    </Flex>
  );
}
